//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.OperationBuilder.js";
let d=[[[0,"AngularPlaces",1,0],[0,"AngularUnits",1,0],[0,"AutoToggle",1,0],[0,"CommandType",1,0],[0,"DevTolPlaces",1,0],[0,"DeviceName",1,0],[0,"DeviceType",1,0],[0,"GotoAangle",1,0],[0,"GotoBangle",1,0],[0,"HomePtMethod",1,0],[0,"HomePtPoint",1,"Point",0],[0,"HumidityPlaces",1,0],[0,"IdName",1,0],[0,"IdnameMethod",1,0],[0,"IndexSize",1,0],[0,"IntermediatePoint",1,"Point",0],[0,"JumpLabel",1,0],[0,"LinearPlaces",1,0],[0,"LinearUnits",1,0],[0,"ManualToggle",1,0],[0,"MaxToggle",1,0],[0,"MaxValue",1,0],[0,"MinToggle",1,0],[0,"MinValue",1,0],[0,"MoveType",1,0],[0,"NumChar",1,0],[0,"OpName",1,0],[0,"ProgramName",1,0],[0,"ProgramNameMethod",1,0],[0,"ProgramToggle",1,0],[0,"PromptVar",1,0],[0,"QisvarType",1,0],[0,"QisvarValue",1,0],[0,"RevMethod",1,0],[0,"RevName",1,0],[0,"SaveDmlDidLabel",1,0],[0,"SaveDmlPcsLabel",1,0],[0,"SaveDmlPointData",1,0],[0,"SaveDmlVersion",1,0],[0,"SensorName",1,0],[0,"TargetPoint",1,"Point",0],[0,"TemperaturePlaces",1,0],[0,"TemperatureUnits",1,0],[0,"ToolName",1,0],[0,"UserPrompt",1,0],[0,"VarName",1,0],[0,"VarScope",1,0],[0,"VarType",1,0],[0,"VectorPlaces",1,0]],[[["nProgStatements"],"GetProgStatements",{R_:{progStatements:""}},0,0],[["progStatements"],"SetProgStatements",{},1,0]],[]];
SPLM.CAM.InspectionCmmCommandBuilder = class extends SPLM.CAM.OperationBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.InspectionCmmCommandBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.InspectionCmmCommandBuilder.CommandTypes = Object.freeze({
    "EnterStatement" : "EnterStatement", "MeasurementMode" : "MeasurementMode", "DefineHomePoint" : "DefineHomePoint", "MoveMachine" : "MoveMachine", "OutputDecimalPlaces" : "OutputDecimalPlaces", "DeclareVariable" : "DeclareVariable", "QISVariable" : "QISVariable", "PromptforInput" : "PromptforInput", "ProgramLabel" : "ProgramLabel", "JumptoLabel" : "JumptoLabel", "ProgramHeader" : "ProgramHeader", "SensorSelect" : "SensorSelect", "Device" : "Device", "SaveDml" : "SaveDml"});

SPLM.CAM.InspectionCmmCommandBuilder.HomePtMethods = Object.freeze({
    "MachineZero" : "MachineZero", "UserSpecifiedPoint" : "UserSpecifiedPoint"});

SPLM.CAM.InspectionCmmCommandBuilder.MoveTypes = Object.freeze({
    "LinearMove" : "LinearMove", "ArcMove" : "ArcMove", "HomeLocation" : "HomeLocation", "Linear5axis" : "Linear5axis"});

SPLM.CAM.InspectionCmmCommandBuilder.VarScopes = Object.freeze({
    "Global" : "Global", "Common" : "Common", "Local" : "Local"});

SPLM.CAM.InspectionCmmCommandBuilder.VarTypes = Object.freeze({
    "Boolean" : "Boolean", "Integer" : "Integer", "Long" : "Long", "Real" : "Real", "Double" : "Double", "Character" : "Character", "Vector" : "Vector"});

SPLM.CAM.InspectionCmmCommandBuilder.QisvarTypes = Object.freeze({
    "Null" : "Null"});

SPLM.CAM.InspectionCmmCommandBuilder.PromptVars = Object.freeze({
    "Null" : "Null"});

SPLM.CAM.InspectionCmmCommandBuilder.IdnameMethods = Object.freeze({
    "CurrentPartName" : "CurrentPartName", "UserSpecified" : "UserSpecified"});

SPLM.CAM.InspectionCmmCommandBuilder.RevMethods = Object.freeze({
    "CurrentPartRevision" : "CurrentPartRevision", "UserSpecified" : "UserSpecified"});

SPLM.CAM.InspectionCmmCommandBuilder.ProgramNameMethods = Object.freeze({
    "CurrentPartName" : "CurrentPartName", "UserSpecified" : "UserSpecified"});

SPLM.CAM.InspectionCmmCommandBuilder.LinearUnitsOptions = Object.freeze({
    "PartUnits" : "PartUnits", "Millimeters" : "Millimeters", "Centimeters" : "Centimeters", "Meters" : "Meters", "Inches" : "Inches", "Feet" : "Feet"});

SPLM.CAM.InspectionCmmCommandBuilder.AngularUnitsOptions = Object.freeze({
    "DecimalDegrees" : "DecimalDegrees", "Radians" : "Radians", "DegreesMinutesSeconds" : "DegreesMinutesSeconds"});

SPLM.CAM.InspectionCmmCommandBuilder.TemperatureUnitsOptions = Object.freeze({
    "Fahrenheit" : "Fahrenheit", "Centigrade" : "Centigrade"});

SPLM.CAM.InspectionCmmCommandBuilder.DeviceTypeOptions = Object.freeze({
    "Stor" : "Stor", "Term" : "Term", "Print" : "Print", "Comm" : "Comm", "Incr" : "Incr"});

export default SPLM;